<template>
<ul class="sidebar-list">
  <li
    v-for="auditRuleCategory in auditRuleCategories"
    :key="auditRuleCategory.id"
    :class="{active: auditRuleCategory.id === currentAuditRuleCategory.id}"
    class="sidebar-item"
    @click="onAuditRuleCategoryItemClick(auditRuleCategory)"
  >{{auditRuleCategory.name}}&nbsp;&nbsp;({{auditRuleCategory.enabledCount}}/{{auditRuleCategory.count}})</li>
</ul>
</template>

<script>
import {AUDIT_RULE_CATEGORY_SELECT_CHANGED} from './EventKeys'

export default {
  name: 'AuditRuleCategorySidebar',
  data () {
    return {
      auditRuleCategories: [],
      currentAuditRuleCategory: null
    }
  },
  methods: {
    getRuleCategories (flag) {
      this.$api.AuditRuleCategory.getList().then(auditRuleCategories => {
        let count = 0
        let enabledCount = 0
        auditRuleCategories.forEach(auditRuleCategory => {
          count += auditRuleCategory.count
          enabledCount += auditRuleCategory.enabledCount
          Object.freeze(auditRuleCategory)
        })
        let titleCensus = '(' + enabledCount + '/' + count + ')'
        this.$eventBus.emit('getTitleCensus', titleCensus)

        this.auditRuleCategories = Object.freeze(auditRuleCategories)

        if (flag && auditRuleCategories.length > 0) {
          this.setRuleCategoryItem(auditRuleCategories[0])
        }
      }).catch(console.error)
    },
    onAuditRuleCategoryItemClick (auditRuleCategory) {
      if (auditRuleCategory === this.currentAuditRuleCategory) {
        return
      }

      this.setRuleCategoryItem(auditRuleCategory)
    },
    setRuleCategoryItem (auditRuleCategory) {
      this.$eventBus.emit(AUDIT_RULE_CATEGORY_SELECT_CHANGED, this.currentAuditRuleCategory = auditRuleCategory)
    }
  },
  created () {
    this.getRuleCategories(true)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/05Auto-Audit-Rule/AuditRuleCategorySidebar.vue